import { render } from "./PronounMenu.vue?vue&type=template&id=68e97b15&scoped=true"
import script from "./PronounMenu.vue?vue&type=script&lang=js"
export * from "./PronounMenu.vue?vue&type=script&lang=js"

import "./PronounMenu.vue?vue&type=style&index=0&id=68e97b15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e97b15"]])

export default __exports__